import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../../tools/contextLib';
import { EventScheduler } from './eventSchedule/eventScheduler';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Form, Label, Input, FormGroup, Button, UncontrolledAccordion, AccordionItem, AccordionHeader, AccordionBody, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import moment from 'moment';


export class Scheduling extends Component {

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            sortByData: ["Department A->Z", "Department Z->A", "Event A->Z", "Event Z->A"], //I could've made this spelled out in the JSX <option> tags, but this way if we ever need to make this
                                                                                            //parameter data-driven from the database all I need to do is write this to be overwritten by the fetch
                                                                                            //so half of my work will already have been done
            //termData: [",", "."],
            termData: [],
            //deptData: [",", "."],
            deptData: [],
            //createdByData: ["Me", "System", "Me + System"],//This is in service of a parameter that no longer is being used, but it's being left here in case we need to revive it.
                                                            //Odds are low, but not zero.
            //statusData: [",", "."],
            statusData: [],
            //accordionData: [",", "."],
            accordionData: [],
            accordionVisible: false,
            yeartermChoice: "",
            deptChoice: "",
            activeDepartment: "",
            //availableEvents: [",", "."],
            availableEvents: [],
            validSubtypes: ["Please select an event"],
            activeYT: "",
            lastFilter: [],
            submittedFlag: false,
            finalizeOption: false,
            finalizeModal: false,
            semesterEdit: false,
            editLockModal: false,
            confirmLockModal: false,
            confirmLockToSend: [],
            isFinalized: 0,
            availableDays: [],
            buildingList: [],
            roomManageModal: false,
            roomManagement: [],
            roomManageKey: 1,
            allInstructorList: []
        }
        this.getUserInfo();
        
        this.modalToggle = this.modalToggle.bind(this);
        this.child = React.createRef();
    }

    async getUserInfo() { //Even though we're not going through all of the song and dance of validation and logging, we still need to know who this user is and in what capacity they're operating as
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
        });
        this.getFilterOptions();
    }

    async getFilterOptions() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('FilterOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            termData: data.term,
            deptData: data.department,
            statusData: data.status//From here, this will just be '...' and we'll fill it out with proper information later
        })
        var dept = this.props.userLevel;
        dept = dept.substring(0, dept.indexOf('-') - 1);
        this.setState({
            activeDepartment: dept
        })
        this.getDays();
        this.getBuildings();
        this.getAllInstructors();
    }

    async getDays() {//This function gets the list of days that a class can be scheduled for
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('GetDays', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            availableDays: data
        })
    }

    async getBuildings() {//This function gets a list of buildings that have academic rooms in them
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel,
            buildCode: "ALL"
        }
        const response = await fetch('AcadBuildings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            buildingList: data
        })
        this.manageRoomType();
    }

    async getAllInstructors() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('GetAllInstrSecSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            allInstructorList: data
        })
    }

    componentDidMount() {

    }

    checkYTDept(e, type) {//The type parameter is necessary to know what kind of information we're getting, since this same function is used for both parameters.
                            //This function is used to determine whether the user has selected both year/term and department, and if they have to go get the status filter options
                            //If the user hasn't entered both and this is the first one, we'll need to save this selection anyway.
        let options = e.target.options;
        let value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        let dtString = value.join(',');
        if (type == "YT") {
            this.setState({
                yeartermChoice: e.target.value
            })
            if (this.state.deptChoice) {
                this.getStatusFilter(e.target.value, this.state.deptChoice);
            }
        }
        if (type == "DT") {
            this.setState({
                deptChoice: dtString
            })
            if (this.state.yeartermChoice) {
                this.getStatusFilter(this.state.yeartermChoice, dtString);
            }
        }
    }

    async getStatusFilter(YT, DT) {//This function takes the selected year/term and department values, and uses them to find what the available status options are for it
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel,
            yeartermChoice: YT,
            deptChoice: DT
        }
        const response = await fetch('StatusOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            statusData: data
        })
    }

    async applyFilter(e) {
        this.setState({
            activeYT: this.state.yeartermChoice
        })
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const dataInput = new FormData(e.target);
        //The Status and Department parameter values aren't so easily retrieved as the other two, given how they're multi-select we have to break them apart into a string SQL can understand
        //This if check to make sure we've entered everything could theoretically let through a query with no sort by value, but a sort by value is selected by default so accomplishing that
        //would be very hard for the user
        var loc = this.state.termData.filter(function (semester) { return semester.sortorder == dataInput.get('term') });
        if (dataInput.get('term') != "DEFAULT" && dataInput.get('department') != "DEFAULT" && dataInput.get('status') != "...") { 
            const statusString = dataInput.getAll('status').join(',');
            const deptString = dataInput.getAll('dept').join(',');
            if (dataInput.get('term') == null || dataInput.get('dept') == null || statusString == "") {
                return;
            }
            let toSend = {
                userLevel: this.props.userLevel,
                sortby: dataInput.get('sort'),
                term: dataInput.get('term'),
                department: deptString,
                status: statusString
            }
            this.setState({
                lastFilter: toSend//If we ever have to reprocess this filter in cases of when the user adds something and we need to display it immediately, we need to be able to remember what 
                                    //this filter is. this.state.lastFilter will have the values of the filter saved for later
            })
            const response = await fetch('Filter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                accordionData: data,
                accordionVisible: true,
                semesterEdit: loc[0].editable,
                isFinalized: data.filter(obj => obj.finalizedcount = 0).length
            })
            this.findIfDone();
            //let statList = []; //Here we detect whether we'll let Registrar see the option to finalize the term. The option should only be available if there aren't any events in Editing or Submitted mode
            //data.forEach((options) => {
            //    statList.push(options.status)
            //})
            //this.setState({
            //    statusList: statList
            //})
            //console.log("status list: " + JSON.stringify(statList));
            //if ((!statList.includes("Editing") && !statList.includes("Submitted")) || !statList.includes("FINALIZED")) {
            //    this.setState({
            //        finalizeOption: true
            //    })
            //}
        }
        localStorage.setItem("lastFetch", moment());
        this.getEventOptions(dataInput.get('dept'));
    }

    async refreshAccordion(RefreshData) { //This function will be used when we need to reload the displayed information with the same search criteria. We can't use the other function because
                                            //that one's data entry relies on a form event and if we need to refresh this we haven't had a form event that contains the relevant data
        if (RefreshData.term != "DEFAULT" && RefreshData.department != "DEFAULT" && RefreshData.status != "...") {
            let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let toSend = {
                userLevel: this.props.userLevel,
                sortby: RefreshData.sortby,
                term: RefreshData.term,
                department: RefreshData.department,
                status: RefreshData.status
            }
            this.setState({
                lastFilter: toSend
            })
            const response = await fetch('Filter', {//We're using the same controller for this because what we need is the same information
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            localStorage.setItem("lastFetch", moment());
            this.setState({
                accordionData: data,
                accordionVisible: true,
                isFinalized: data.filter(obj => obj.finalizedcount = 0).length
            })
            this.findIfDone();
        }
        this.getEventOptions(RefreshData.department);
    }

    async getEventOptions(dept) { //This retrieves dropdown information for the Add a New Course Section menu
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel,
            department: dept
        }
        const response = await fetch('GetEventOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            availableEvents: data
        })
        this.findIfDone();
    }

    async getSubtypes(e) { //This retrieves subtypes based on which event from the previous function you picked
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel,
            eventid: e.target.value
        }
        const response = await fetch('GetSubtypeOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            validSubtypes: data
        })
    }

    async addSection(e) { //This is the go button that adds the specified section to the year/term that's being used.
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.userLevel,
            eventid: dataInput.get('eventid'),
            subtype: dataInput.get('subtype'),
            yearterm: this.state.activeYT
        }
        const response = await fetch('AddSection', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        if (data.output == "lock") {
            this.setState({
                editLockModal: true
            })
        }
        else {
            this.setState({
                submittedFlag: data.output == "true" ? true : false
                })
        }
        this.refreshAccordion(this.state.lastFilter);
        setTimeout(() => {
            this.setState({
                submittedFlag: false
            })
        }, 5000)
    }

    actionRender = (refreshList) => { //This is a callback function from the child component that asks the parent to rerender the accordion list after an action was taken in the eventScheduler component
                                        //Once the user selects an action to change the event status, that change needs to be reflected on this level
        this.setState({
            accordionData: refreshList,
            accordionVisible: true
        })
        this.getStatusFilter(this.state.yeartermChoice, this.state.deptChoice);
        let statList = [];
        refreshList.forEach((options) => {
            statList.push(options.status)
        })
        this.findIfDone();
    }

    async findIfDone() { //If an action to change the status of an event makes it now legal to finalize the term, this function will find it
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userLevel,
            currentTermSPID: this.state.activeYT
        }
        const response = await fetch('FinalizeLegal', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        if (data.finalizeflag == "true") {
            this.setState({
                finalizeOption: true
            })
        }
    }

    async bulkAction(input) { //Registrar will have the option to perform bulk actions to either approve all submitted or deny all submitted
        if (input.target.value == "Finalize") {
            let statList = [];
            this.state.accordionData.forEach((data) => {
                statList.push(data.status)
            })
            if (!statList.includes("Editing") && !statList.includes("Submitted")) {
                this.modalToggle();
                return; 
            }
        }
        let pkList = [];
        this.state.accordionData.forEach((data) => {
            pkList.push(data.pk)
        })
        let sendPKList = pkList.join(','); //We're getting a list of all visible events for approval or denial. This will scoop up everything shown regardless of status, but events that can't be
                                            //approved or denied won't be moved into Approved or Denied anyway
        let toSend = {
            userLevel: this.props.userLevel,
            action: input.target.value,
            targets: sendPKList
        }
        if (input.target.value == "Lock") {
            this.setState({
                confirmLockModal: true,
                confirmLockToSend: toSend
            })
            return;
        }
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('Action', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
            this.setState({
                accordionData: [],
                accordionVisible: false
            })
            this.getFilterOptions();
        //window.location.reload(false);//Once again, I tried to do this like a normal person and I still have nightmares about what happened.   
    }


    findIfDoneProp = (dataFromChild) => {
        this.setState({
            finalizeOption: dataFromChild
        })
    }

    modalToggle() {
        this.setState({
            finalizeModal: !this.state.finalizeModal
        })
    }

    async finalize() { //This function doesn't have a proper procedure behind it yet, all it does for now is flip all of the Approved statuses to Finalized. The part that actually feeds Campus6_40
                        //with this data is coming soon.
        let toSend = {
            userLevel: this.props.userLevel,
            yearterm: this.state.lastFilter.term
        }
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('FinalizeSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.modalToggle();
        this.refreshAccordion(this.state.lastFilter);
    }

    toggleLockModal() {
        this.setState({
            editLockModal: !this.state.editLockModal
        })
    }

    toggleConfirmLock() {
        this.setState({
            confirmLockModal: !this.state.confirmLockModal
            })
    }

    async confirmLock() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        this.setState({
            confirmLockModal: false
        })
        const response = await fetch('Action', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(this.state.confirmLockToSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        //window.location.href = window.location.href; //UPDATE 20230327: Switching away from routing-based control over which main component is displayed means that this doesn't work well anymore.
        this.setState({
            accordionData: [],
            accordionVisible: false
        })
        this.getFilterOptions();
        this.props.refreshAll();
    }

    accordionDisplay() {//The accordion shouldn't be displayed until after the filter is applied. Because this accordion needs to iterate through something, instead of managing that on top of
        //hidden divs, we just don't even have it there to hide until the fetch gives us something to iterate through.
        return (<UncontrolledAccordion stayOpen defaultActiveKey="0" style={{ visibility: this.state.accordionVisible == true ? 'visible' : 'hidden' }}>
            <AccordionItem hidden={!this.state.semesterEdit} >
                {/*The majority of this accordion will be iteratively generated based on the events that are returned. However, no matter what we have to display to the user, we will*/}
                {/*always need to give the user the option to add a new section to this term. Therefore, this accordion option is spelled out right at the beginning to give them that option.*/}
                <AccordionHeader targetId="createnew">
                    Add a Course Section...
                </AccordionHeader>
                <AccordionBody accordionId="createnew">
                    <div>
                        <Form className="d-flex" onSubmit={this.addSection.bind(this)}>
                            <FormGroup>
                                <Label>Event ID</Label>
                                <Input type="select" name="eventid" id="eventid" defaultValue="DEFAULT" onChange={this.getSubtypes.bind(this)}>
                                    <option disabled value="DEFAULT">Select Event...</option>
                                    {this.state.availableEvents.map(events => (
                                        <option>{events}</option>
                                        ))}
                                </Input>
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>Subtype</Label>
                                <Input type="select" name="subtype" id="subtype" defaultvalue="DEFAULT">
                                    <option disabled value="DEFAULT">...</option>
                                    {this.state.validSubtypes.map(subtypes => (
                                        <option>{subtypes}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <Button type="submit" outline color="success">Add</Button>&emsp;<div style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }} /></div>
                        </Form>
                    </div>
                </AccordionBody>
            </AccordionItem>
            {/*Now that we've given the user the option to add new events, we'll loop through the events we currently have and make accordion items for them.*/}
            {this.state.accordionData.map(events => (
                <AccordionItem>
                    <AccordionHeader targetId={"event" + events.pk}>
                        <Table size="sm">
                                <tr>
                                    <td  style={{ textAlign: 'left', width: 100}}><Badge pill color={events.badgecolor}>{events.status}</Badge></td>
                                    <td  style={{ textAlign: 'left', width: 400 }}>{events.eventid} {events.subtype}  SEC {events.sectionid}  ({events.deptname})</td>
                                    <td  style={{ textAlign: 'left' }}>{events.credlimit}</td>
                                    <td  style={{ textAlign: 'right'}}>{events.createinfo}</td>
                                </tr>
                        </Table>
                    </AccordionHeader>
                    <AccordionBody accordionId={"event" + events.pk}>
                        {/*Within the body is just the EventSchedule child component. We pass a number of props to this, but the most important one is the event PK. This identifies which record*/}
                        {/*in the StagingTable_Sections table this EventScheduler component needs to display, which makes the fetches within this component much simpler. The key prop is also critical,*/}
                        {/*as this one helps this component understand which child component needs to be associated with what.*/}
                        <EventScheduler
                            eventpk={events.pk}
                            eventstatus={events.status}
                            key={events.pk}
                            reEvaluateAction={action => this.actionReevaluate = action}
                            actionRerender={this.actionRender}
                            activeFilter={this.state.lastFilter}
                            ref={this.child}
                            refreshFinal={this.findIfDoneProp}
                            editable={this.state.semesterEdit}
                            userData={this.state.returnable}
                            availableDays={this.state.availableDays}
                            availableBuildings={this.state.buildingList}
                            availableInstr={this.state.allInstructorList}
                        />
                    </AccordionBody>
                </AccordionItem>
            ))}
        </UncontrolledAccordion>);
    }

    

    render() {
        
        let displayAccord = <div></div>
        if (this.state.accordionVisible == true) {
            displayAccord = this.accordionDisplay();
        } //Here we decide whether we want to display the accordion at all
        
    return (
        <div>
            <Modal isOpen={this.state.editLockModal} toggle={this.toggleLockModal.bind(this)}>
                <ModalHeader toggle={this.toggleLockModal.bind(this)}>ERROR: Semester Locked</ModalHeader>
                <ModalBody>
                    <div classname="tooltipLinebreakCustom">This semester has been edit locked. Please wait for the Registrar to unlock it before performing this action.</div>
                </ModalBody>
                <ModalFooter></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.confirmLockModal} toggle={this.toggleConfirmLock.bind(this)}>
                <ModalHeader toggle={this.toggleConfirmLock.bind(this)}>Lock Semester</ModalHeader>
                <ModalBody>
                    <div className="tooltipLinebreakCustom">
                        Edit locking a semester will disallow any new sections from being added to the semester and will prevent un-deleting any deleted sections.<br />
                        Do you want to switch the edit lock on this semester?
                    </div>
                </ModalBody>
                <ModalFooter><Button color="primary" onClick={this.confirmLock.bind(this) }>Yes</Button>&emsp;<Button onClick={this.toggleConfirmLock.bind(this)}>Go Back</Button></ModalFooter>
            </Modal>
            <br />
            <Form className="d-flex" inline onSubmit={this.applyFilter.bind(this)}>
                <FormGroup >
                    <Label >Sort By<p /></Label>
                    <Input type="select" name="sort" id="sort" >
                        {this.state.sortByData.map(option => (
                            <option>{option}</option> 
                            ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Year/Term<p /></Label>
                    <Input type="select" name="term" id="term"  defaultValue="DEFAULT" onChange={(e) => this.checkYTDept(e, "YT")}>
                        <option value="DEFAULT" disabled={true}>Please select...</option>
                        {this.state.termData.map(option => (
                            <option value={option.sortorder }>{option.yearterm}</option>
                        ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Department<br /><div style={{ fontSize: 10 }}>(Hold CTRL for multi-select)</div></Label>
                    <Input type="select" name="dept" id="dept" multiple onChange={(e) => this.checkYTDept(e, "DT")}>
                        {this.state.deptData.map(option => (
                            <option value={option.codekey}>{option.deptname}</option>
                        ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Status<br /><div style={{ fontSize: 10 }}>(Hold CTRL for multi-select)</div></Label>
                    <Input type="select" multiple name="status" id="status" >
                        {this.state.statusData.map(option => (
                            <option>{option}</option>
                        ))}
                    </Input>
                </FormGroup >
                &nbsp;
                <Button type="submit" color="success" outline size="sm" className={"w-15"}>Apply</Button>
            </Form>
            <div className="rightAlignCustom" style={{ visibility: this.state.accordionVisible == true && this.state.activeDepartment == "REGISTRAR" ? 'visible' : 'hidden' }}>
                <div className="inlineCustom" style={{ visibility: this.state.accordionVisible == true && this.state.activeDepartment == "REGISTRAR" ? 'visible' : 'hidden' }}>
                <Input type="select" name="bulkAction" id="bulkAction" value="DEFAULT" onChange={this.bulkAction.bind(this)}>
                    <option value="DEFAULT">Global Actions...</option>
                    <option value="Approve">Approve These</option>
                    <option value="Deny">Deny These</option>
                    {this.state.isFinalized == 0 && <option value="Lock">{this.state.semesterEdit == true ? "L" : "Unl"}ock Semester</option>}
                        {this.state.finalizeOption == true && !this.state.semesterEdit && <option value="Finalize" >FINALIZE SEMESTER</option>}
                    </Input></div>
                <Modal isOpen={this.state.finalizeModal} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>Confirm</ModalHeader>
                    <ModalBody>
                        This action is irreversible and will immediately move all Approved sections into production.<p />
                        Are you sure you want to do this?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.finalize.bind(this)}>Yes</Button>
                        <Button color="secondary" onClick={this.modalToggle}>No</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <br />
            <br />
            <br />
            {displayAccord}
        </div>
        );
    }
}